import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { hotComics } from '@/mocks/comics';

export default function HotComics() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const amount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -amount : amount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section id="hot" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/70 px-3 py-1 rounded-full mb-3">
              热门推荐
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
              大家都在
              <span className="text-primary-500">追</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-2">千万读者的共同选择，热度持续飙升</p>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900 transition-colors cursor-pointer"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900 transition-colors cursor-pointer"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto scrollbar-hide pb-2"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {hotComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="flex-shrink-0 w-44 md:w-52 group"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-background-100">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 哔咔漫画热门推荐`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs bg-primary-500 text-background-50 px-2 py-0.5 rounded-full">
                    {comic.category}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="text-xs bg-background-50/90 text-foreground-800 px-2 py-0.5 rounded-full font-medium">
                    {comic.rating}
                  </span>
                </div>
              </div>
              <h3 className="font-heading text-base text-foreground-900 font-bold mb-1 group-hover:text-primary-600 transition-colors truncate">
                {comic.title}
              </h3>
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <span>{comic.author}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                <span>{comic.views}阅读</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}